import { SETTINGS_ACTIONS } from './settingsActionMap';
import { createScopedDispatchers } from 'shared/helpers/shared/selectHandlers/createScopedDispatchers';

const { selectSpecificLocationDispatch } = createScopedDispatchers(SETTINGS_ACTIONS, 'switch');

export const selectSpecificLocationIndicatorDispatcherHandler = (dispatch, name, specificLocationList, machineList, newSpecificLocations) =>
  selectSpecificLocationDispatch(dispatch, name, specificLocationList, machineList, newSpecificLocations);
